import React, { useCallback } from "react";
import { Grid, Stack, Tooltip } from "@mui/material";
import moment from "moment";
import { useNavigate } from "react-router-dom";

import Avatar from "../../../../components/Avatar";
import {
  createAvtarName,
  fixedDigitsAfterDecimal,
  hasImage,
} from "../../../../utils";
import { useCustomSearchParams } from "../../../../hooks/useCustomSearchParams";
import { useResponsive } from "../../../../hooks/useResponsive";
import { useSetMultipleParams } from "../../../../hooks/useSetMultipleParams";
import { ByBoardAndUserProgressBar } from "./ByBoardAndUserProgressBar";

function Item({ worklog }) {
  const navigate = useNavigate();
  const [data, updateSearchParams] = useCustomSearchParams("card_id");
  const isMobile = useResponsive("down", "md");
  const [setMultipleSearchParams] = useSetMultipleParams();
  const openBoard = useCallback(() => {
    navigate(`/board/${worklog?.key}`);
  }, [navigate, worklog?.key]);

  const localCreatedAt = moment.utc(worklog?.cardlog?.created_at)?.local();
  const localDateTime = moment.utc(worklog?.cardlog?.date_time)?.local();

  function isSameDay(moment1, moment2) {
    return moment1?.isSame(moment2, "day");
  }
  const sameDay = isSameDay(localCreatedAt, localDateTime);
  const handleOpenCardDetail = useCallback(
    (boardId, cardId) => {
      setMultipleSearchParams([
        {
          name: "brd_id",
          value: boardId,
        },
        {
          name: "card_id",
          value: cardId,
        },
      ]);
    },
    [setMultipleSearchParams]);

  return (
    <>
      {worklog && (
        <Grid
          container
          spacing={2}
          className="worklog-item d-flex justify-content-space-between">
          {isMobile ? (
            <Grid
              item
              xs={12}
              md={9}
              sx={{
                paddingLeft: "0px !important",
                paddingRight: "0px !important",
              }}>
              <Stack
                direction={"row"}
                justifyContent={"space-between"}
                alignItems={"center"}
                flexWrap={"wrap"}>
                <Stack
                  direction={"row"}
                  alignItems={"center"}
                  spacing={1}
                  width={"100%"}>
                  <Avatar
                    username={`${worklog?.cardlog?.user?.first_name} ${worklog?.cardlog?.user?.last_name}`}
                    user_image={worklog?.cardlog?.user?.user_image}
                    title={`${worklog?.cardlog?.user?.first_name} ${worklog?.cardlog?.user?.last_name}`}
                    className="user-avtar-dropdown user-avatar mr-8 cursor-pointer"
                    style={
                      !hasImage(worklog?.cardlog?.user?.user_image) && {
                        bgcolor:
                          worklog?.cardlog?.user?.profile_color?.background,
                        color: worklog?.cardlog?.user?.profile_color?.text,
                      }
                    }
                    onClick={() => {
                      navigate(
                        `/my-task?tab=team&uid=${worklog?.cardlog?.user?.user_id}`
                      );
                    }}>
                    {createAvtarName(
                      `${worklog?.cardlog?.user?.first_name} ${worklog?.cardlog?.user?.last_name}` ||
                        ""
                    )}
                  </Avatar>
                  <Stack direction={"column"} width={"100%"}>
                    <Stack
                      direction={"row"}
                      alignItems={"center"}
                      justifyContent={"space-between"}
                      spacing={1}>
                      <Stack
                        direction={"row"}
                        alignItems={"center"}
                        spacing={1}>
                        <div className="d-flex align-items-center primary_underline">
                          <Tooltip title={worklog?.board_name}>
                            <a
                              className="board-anquor cursor-pointer"
                              onClick={openBoard}>
                              {`${worklog?.key}`.toUpperCase()}
                            </a>
                          </Tooltip>
                          -
                          <a
                            className="board-anquor cursor-pointer"
                            onClick={() => {
                              updateSearchParams(
                                "card_id",
                                worklog?.cardlog?.card?.card_id
                              );
                            }}>
                            {worklog?.cardlog?.card?.card_id}:
                          </a>
                        </div>
                        {worklog.epic_name && (
                          <div className="card-epic-tag mr-1">
                            <p className="card-epic-tag-text">
                              {worklog?.epic_name}
                            </p>
                          </div>
                        )}
                      </Stack>
                      <p className="worklog-status">
                        {worklog?.workflow_step_name}
                      </p>
                    </Stack>
                    <Stack
                      direction={"row"}
                      justifyContent={"space-between"}
                      alignItems={"center"}
                      flexWrap={"wrap"}
                      className="mt-1">
                      <p className="worklog-title mr-2">
                        {worklog?.cardlog?.card?.title}
                      </p>
                      <p className="hours">
                        {fixedDigitsAfterDecimal(worklog?.cardlog?.hours_spent)}{" "}
                        Hour
                      </p>
                    </Stack>
                  </Stack>
                </Stack>
              </Stack>
            </Grid>
          ) : (
            <Grid item xs={12} md={9}>
              <div className="d-flex w-100">
                <Avatar
                  username={`${worklog?.cardlog?.user?.first_name} ${worklog?.cardlog?.user?.last_name}`}
                  user_image={worklog?.cardlog?.user?.user_image}
                  title={`${worklog?.cardlog?.user?.first_name} ${worklog?.cardlog?.user?.last_name}`}
                  className="user-avtar-dropdown user-avatar mr-8 cursor-pointer"
                  onClick={() => {
                    navigate(
                      `/my-task?tab=team&uid=${worklog?.cardlog?.user?.user_id}`
                    );
                  }}
                  style={
                    !hasImage(worklog?.cardlog?.user?.user_image) && {
                      bgcolor:
                        worklog?.cardlog?.user?.profile_color?.background,
                      color: worklog?.cardlog?.user?.profile_color?.text,
                    }
                  }>
                  {createAvtarName(
                    `${worklog?.cardlog?.user?.first_name} ${worklog?.cardlog?.user?.last_name}` ||
                      ""
                  )}
                </Avatar>
                <div className="w-100">
                  <div className="d-flex justify-content-space-between align-items-baseline">
                    <div className="d-flex align-items-baseline">
                      <Tooltip title={worklog?.board_name}>
                        <a
                          className="board-anquor cursor-pointer"
                          onClick={openBoard}>
                          {`${worklog?.key}`?.toUpperCase()}
                        </a>
                      </Tooltip>
                      -
                      <a
                        className="board-anquor cursor-pointer mr-1"
                        onClick={() =>
                          handleOpenCardDetail(
                            worklog?.cardlog?.card?.board_id,
                            worklog?.cardlog?.card?.card_id
                          )
                        }>
                        {worklog?.cardlog?.card?.card_id}:
                      </a>
                      <p className="worklog-title mr-2">
                        {worklog?.cardlog?.card?.title}
                      </p>
                      {worklog?.epic_name && (
                        <div className="card-epic-tag mr-2">
                          <p className="card-epic-tag-text">
                            {worklog?.epic_name}
                          </p>
                        </div>
                      )}
                    </div>
                    <p className="hours min-width-60">
                      {fixedDigitsAfterDecimal(worklog?.cardlog?.hours_spent)}{" "}
                      Hour
                    </p>
                  </div>
                  <p
                    className="worklog-worklog"
                    dangerouslySetInnerHTML={{
                      __html: worklog?.cardlog?.work_performed,
                    }}></p>
                </div>
              </div>
            </Grid>
          )}
          <ByBoardAndUserProgressBar sameDay={sameDay} worklog={worklog} />
        </Grid>
      )}
    </>
  );
}

export default Item;
